class Student {
    static enrollCourse = (courseId, studentId, cb) => {
        console.log("Enrolling into the course ", courseId, "student id is ", studentId)
    }
}

export default Student